import Swiper, { Pagination } from 'swiper';

const SwiperContent = function () {
  
  // configure Swiper to use modules
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-content' );

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 20,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        loop: false,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: false
          }
        }
      })
    });
  }

  // let btnText = $('.btn-tertiary').find('h2');
  // let text = btnText.html();
  // if ( text.length <= 17 ) {
  //   btnText.addClass('narrow');
  // }

}

export default SwiperContent;